import type { IconName } from '@usealloy/component-library';
import {
  Badge,
  getTextColorForBackground,
} from '@usealloy/component-library';

interface Props {
  color: string;
  icon: IconName;
}

export const OutcomeIcon = ({
  color,
  icon,
}: Props) => (
  <Badge
    color={getTextColorForBackground(color)}
    icon={icon}
    iconSize="small"
    style={{ backgroundColor: color }}
  />
);
